<template>
    <div class="article">
        <div class="info">
            <div class="title">业务视频标题123</div>
            <div class="date flex-box"><span>发布人: 李一一</span><span>{{date | date}}</span></div>
        </div>
        <div class="contant">
                这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该
业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文
案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业
的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这
里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的
相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里
是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里。<br/><br/>

    关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这
里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的
相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里
是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相
关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务。<br/><br/>

    该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关
介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关于该业务的相关介绍文案这里是关
于该业务的。<br/><br/>
        </div>
        <div class="btn">
            <button @click="nextPiece(info.last.id)">上一篇: {{info.last.title}} </button> <button @click="nextPiece(info.next.id)">下一篇: {{info.next.title}}</button>
        </div>
    </div>
</template>
<script>
import timeStamp from '@/utils/timeStamp'
    export default{
        data(){
            return{
                date:  new Date('2021-1-1 12:12:12'),
                info:{
                    last: {
                        id: 321,
                        title: '未来的展望'
                    },
                    next: {
                        id: 456,
                        title: '拓展业务'
                    }
                }
            }
        },
        methods:{
            nextPiece( id ) {
                if( !id ) return
                let route = this.$route
                let path = `${route.path}?arId=${id}&navId=${route.query.navId}${route.hash}`
                this.$router.replace({
                    path: path,
                })

            }
        },
        filters:{
            date: value =>  timeStamp(value)
        },
      
    }
</script>
<style lang="scss" scoped>
    .article{
        font-size: 0.12rem;
    }
    .info{
        text-align: center;
    }
    .date{
        width: 2.7rem;
        margin:0.15rem auto;
        color: #909090;
        span{
            display: block;
        }
        :nth-child(1){
            padding-right: 0.15rem;
            border-right: 1px solid #909090;
        }

    }
    .btn{
        button{
            border: none;
            background-color: #fff;
            font-size: 0.14rem ;
        }
        :nth-child(2){
            color: #FF4848;
        }
    }
    
</style>
